import React from 'react'
import { useRouter } from 'next/router'

import { oSeriesPages } from 'types/oSeriesPages'

import useOrder from 'utils/hooks/useOrder'
import { isGlobalContextOrderValid } from 'utils/orderHelper'
import Loader from 'components/o_series/common/Loader'
import { addRiskifiedUUIDToSession } from 'utils/sessionHelper'

type Props = {
  children: React.ReactNode
}

function EnsureOrderIsLoaded({ children }: Props): JSX.Element {
  const router = useRouter()
  const { isLoading, order } = useOrder()

  if (isLoading) {
    return (
      <div className="pt-32 px-7 max-w-md mx-auto">
        <Loader />
      </div>
    )
  }

  if (!isGlobalContextOrderValid(order)) {
    router.replace(
      `/${router.locale}/${router.query.pipe}/${oSeriesPages.landing}`
    )

    return null
  }

  // Riskified integration
  if (router.query.riskified_cart_id) {
    addRiskifiedUUIDToSession(router.query.riskified_cart_id as string)
  }

  return <>{children}</>
}

export default EnsureOrderIsLoaded
